module.exports = __webpack_public_path__ + "static/media/bannermako2.5fbcb772.svg";